export default __webpack_public_path__ + "static/latitude-gem-front-a83bf44f49098558ba60678c261c29a9.png";